import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();
let userData = JSON.parse(localStorage.getItem("tokenData"))

headers.append('Content-Type', 'application/json');
options.headers = headers;


export async function activateMarket(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/activateMarket"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function deActivateMarket(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/usermarketcontrol/deactivateMarket"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function activateMarketBet(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/marketcondition/betlock"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function deActivateMarketBet(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/marketcondition/betunlock"
    try {
        const response = await serviceContext.put(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function updateMarket(data) {
    let url = ""
    data.username = userData.sub
    url = "usermgnt/marketcondition"
    try {
        const response = await serviceContext.post(url, JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }

};

// export async function getMarketExpo(mkts) {
//     // let url = "usermgnt/event/openbetmarkets/"+mkts.toString()
//     let url = ReportsURL + "results/markets/"+mkts.toString()
//     try {
//         const response = await serviceContext.get(url, null, options);
//         if (response.hasError === true) {
//             return false;
//         }
//         else {
//             const res = response.json();
//             return res;
//         }
//     }
//     catch (error) {
//         return error;
//     }
// };

export async function getEventResults(evt) {
    // let url = "usermgnt/event/openbetmarkets/"+mkts.toString()
    let url = `${ReportsURL}result/open/event/${evt}` //ReportsURL + "results/event/"+evt
    try {
        const response = await serviceContext.get(url, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};


export async function getUserBooks(user,market) {
    let url = `${ReportsURL}result/open/user/market/${user}/${market}`;//ReportsURL + "results/user/market/"+user+"/"+market
    try {
        const response = await serviceContext.get(url, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function getUserMarketLock(eventId, marketType) {
    try {
        const response = await serviceContext.get("gamecontrol/sportcontrol/event/"+ eventId +"/" + marketType, null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

export async function addUserMarketLock(data) {

    try {
        const response = await serviceContext.post("query/bets/usermarket/lock", JSON.stringify(data), options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};